<template>
  <div class="custom-drop-down" :class="{'fix-to-right': fixToRight, 'fix-to-left': !fixToRight}">
    <div ref="dropDownButton" class="custom-drop-down-button" :class="{'active': show}" @click="handleOpenDropDown">
      <slot name="button">
      </slot>
      <div ref="dropDownArrow" class="custom-drop-down-button-arrow">
        <custom-icon icon="chevron-down-icon" height="15px" width="15px" color="dark-gray" />
      </div>
    </div>
    <transition :css="false"
                @before-enter="beforeEnterRow"
                @enter="enterRow"
                @leave="leaveRow">
      <div class="custom-drop-down-wrapper"
           ref="dropDownWrapper"
           v-show="show">
        <div ref="dropDownTriangle" class="dropdown-triangle"></div>

        <ul>
          <li class="drop-down-list"
              :class="item.color ? `text-${item.color}` : ''"
              v-for="(item, item_index) in list"
              v-if="checkUserPermissions(item.permission) && JSON.stringify(item) !== JSON.stringify(selectedItem)"
              :key="item_index"
              @click="handleClick(item)">

            <div v-if="item.type === 'html'"
                 v-html="item.html"/>

            <router-link v-else-if="item.type === 'link'"
                         :to="item.route || item.id">
              <custom-icon v-if="item.icon && (item.iconPack === 'useral')"
                           :icon="item.icon"
                           :color="item.color"
                           :width="getIconSize"
                           :height="getIconSize"/>
              <vs-icon v-else :icon="item.icon"
                       :icon-pack="item.iconPack"/>

              <span>
                {{ $t(item.i18n) || item.label }}
              </span>
            </router-link>

            <div v-else-if="item.type === 'img'">
              <img :src="item.src" :class="item.imgClass ? item.imgClass : ''" loading="lazy">
              {{ $t(item.i18n) || item.label }}
            </div>

            <div v-else>
              <custom-icon v-if="item.icon && (item.iconPack === 'useral')"
                           :icon="item.icon"
                           :color="item.color"
                           :width="getIconSize"
                           :height="getIconSize"/>
              <vs-icon v-else class="mr-1"
                       :icon="item.icon"
                       :icon-pack="item.iconPack"/>

              <span>
                {{ $t(item.i18n) || item.label }}
              </span>
            </div>
          </li>
        </ul>
      </div>
    </transition>

    <div class="custom-drop-down-overlay"
         @click="$emit('closed'), show = false"
         v-if="show"></div>
  </div>
</template>

<script>
import gsap from 'gsap'
import CustomIcon from '@/components/icon/customIcon.vue'
import {mapGetters} from 'vuex'

export default {
  name: 'customDropDown',
  components: {CustomIcon},
  props: {
    defaultShow: {
      type: Boolean,
      default: false
    },
    selectedItem: {
      type: Object,
      default: () => { return {} }
    },
    list: {
      type: Array,
      default: () => { return [] }
    },
    fixToRight: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      show: false
    }
  },
  computed: {
    ...mapGetters(['isMobile']),
    getIconSize () {
      if (this.isMobile) {
        return '25px'
      } else {
        return '32px'
      }
    }
  },
  created () {
    this.show = this.defaultShow
  },
  methods: {
    handleClick (item) {
      if (item.hasOwnProperty('event')) this.$emit(item.event, item)
      else this.$emit('clicked', item)
      this.$emit('closed')
      this.show = false
    },
    beforeEnterRow (el) {
      el.style.opacity = 0
      el.style.transform = 'translate(0px, -30px)'
    },
    enterRow (el, done) {
      gsap.to(el, {
        opacity: 1,
        y: '0',
        delay: el.dataset.index * 0.35,
        onComplete: done
      })
    },
    leaveRow (el, done) {
      gsap.to(el, {
        opacity: 0,
        y: '-30px',
        delay: el.dataset.index * 0.35,
        onComplete: done
      })
    },
    handleOpenDropDown () {
      this.show = true
      this.$refs.dropDownWrapper.style.minWidth = `${this.$refs.dropDownButton.clientWidth}px`
      this.$refs.dropDownWrapper.style.top = `${this.$refs.dropDownArrow.offsetTop + 20}px`
      this.$refs.dropDownTriangle.style.left = `${this.$refs.dropDownArrow.offsetLeft - 1}px`
    },
    checkUserPermissions (permission) {
      return permission ? this.$u.checkPermissions(permission) : true
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-drop-down {
  .custom-drop-down-button {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    gap: 5px;
    padding: 5px;
    cursor: pointer;

    .custom-drop-down-button-arrow {
    }

    &.active {
      border: 1px solid #cecece;
      border-radius: 0.5rem;
    }
  }

  &.fix-to-right {

    .custom-drop-down-wrapper {
      left: 0;
    }
  }

  &.fix-to-left {

    .custom-drop-down-wrapper {
      right: 0;
    }
  }

  .custom-drop-down-wrapper {
    position: absolute;
    top: 40px;
    background: #333333;
    padding: 10px;
    //right: 0;
    //min-width: 125px;
    border-radius: 5px;
    border: 1px solid #555555;
    z-index: 12000;

    .dropdown-triangle {
      position: absolute;
      top: -8px; /* قرارگیری بالای منو */
      left: 5px; /* تنظیم مکان مثلث نسبت به آیکون */
      width: 0;
      height: 0;
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
      border-bottom: 8px solid #fff; /* رنگ پس‌زمینه منو */
      z-index: 1001;
    }

    ul {

      li.drop-down-list {
        cursor: pointer;
        line-height: 30px;
        padding: 5px 0;
        border-bottom: 1px solid #555555;

        &:first-child {
          padding-top: 0;
        }

        &:last-child {
          border: none;
          padding-bottom: 0;
        }

        div,
        a {
          display: flex;
          align-items: center;
          gap: 5px;
        }
      }
    }
  }

  .custom-drop-down-overlay {
    //cursor: pointer;
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    z-index: 10000;
  }
}
</style>
